export default "__VITE_ASSET__TrR4RkKE__"